import React from 'react';
import { useNavigate } from 'react-router-dom';
type Props = {title:string; img:string; price:string; meta?:string};
export function ProductCard({title,img,price,meta,landScapeImg}:Props){
  const navigate = useNavigate();

  const goToSafety = () => navigate('/safety');

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      goToSafety();
    }
  };
  return (
    <article className={landScapeImg ? "product-card-landscape":"product-card"}>
         <img
        src={img}
        alt={title}
        role="link"
        tabIndex={0}
        onClick={goToSafety}
        onKeyDown={onKeyDown}
        style={{ cursor: 'pointer' }}
        aria-label={`View safety products for ${title}`}
      />
     
      <style>{`
        .product-card{background:#fff;border:1px solid var(--border);border-radius:12px;padding:12px}
        .product-card img{width:100%;height:140px;object-fit:cover;border-radius:8px}
        .product-card-landscape img{width:100%;object-fit:cover;border-radius:8px}
        .product-card h3{font-size:16px;margin:8px 0 4px}
        .product-card .meta{font-size:14px;color:#64748b;margin:0 0 8px}
        .product-card .price{font-weight:700;margin:6px 0 10px}
        .product-card .actions{display:flex;gap:8px}
        .btn{height:40px;padding:0 14px;border-radius:10px;border:1px solid transparent;font-weight:600}
        .btn.primary{background:var(--brand);color:#fff}
        .btn.primary:hover{background:var(--brand-700)}
        .btn.ghost{background:#fff;border-color:var(--brand);color:#035b7c}
      `}</style>
    </article>
  );
}
